import React, {Dispatch, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link, NavLink, useHistory} from 'react-router-dom';

import {DropdownMenu} from './DropdownMenu';

// @ts-ignore
import {EventSourcePolyfill} from 'event-source-polyfill';
import {isConnected} from '../_selectors/rtms';
import {User} from '../_services/User';
import {logout} from '../_actions/user';

type NavbarProps = {
    dispatchUserLogout: () => void;
    isRtmsConnected: boolean;
    brandingOnly?: boolean;
    brandingDisplayName?: string;
};

const Navbar: React.FunctionComponent<NavbarProps> = ({
                                                          dispatchUserLogout,
                                                          isRtmsConnected,
                                                          brandingOnly = false,
                                                          brandingDisplayName = ''
                                                      }): JSX.Element => {
    // @ts-ignore
    const [inboxCount, setInboxCount] = useState<number>(0);
    const [showMobileNav, setShowMobileNav] = useState<boolean>(false);
    const [searchEntryId, setSearchEntryId] = useState<string>('');
    const history = useHistory();

    useEffect(() => {
        /*
        const es = new EventSourcePolyfill('/p/flow/api/inbox-count', {
            headers: {
                'Authorization': 'Bearer ' + User.getInstance().getAuthToken()
            }
        });
        es.onmessage = function (event: any) {
            if (inboxCount !== event.data) {
                setInboxCount(event.data > 99 ? '...' : event.data);
            }
        };

        return () => {
            es.close();
        };
         */
    });

    const handleSearchEntryById = () => {
        history.push('/entry/' + searchEntryId);
        setSearchEntryId('');
    }

    const navbarCollapseClasses = [
        'collapse',
        'navbar-collapse',
        showMobileNav && 'show',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <nav className="navbar navbar-expand-md navbar-light fixed-top">
            <button type="button"
                    className="navbar-toggler"
                    data-toggle="collapse"
                    data-target="#navbarCollapse"
                    aria-controls="navbarCollapse"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    onClick={() => {
                        setShowMobileNav(!showMobileNav);
                    }}
            >
                <span className="navbar-toggler-icon"/>
            </button>
            {
                // @ts-ignore - COMPANY defined in webpack as build constant
                COMPANY === 'abnex' ?
                    <img src="/p/flow/img/abnex_logo.jpg"
                         height={30}
                         alt=""
                         className="mr-3"
                    />
                    :
                    <img src="https://s7d3.scene7.com/is/image/ThomasBetts/abb-logo?fmt=png-alpha&hei=50"
                         height={30}
                         alt=""
                         className="mr-3"
                    />
            }
            {brandingOnly ?
                <span className="navbar-brand">{brandingDisplayName || 'Fletch'}</span>
                :
                <Link to="/" className="navbar-brand">Fletch</Link>
            }
            {!brandingOnly &&
                <div className={navbarCollapseClasses}>
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item">
                            <NavLink exact={true} to="/" className="nav-link" href="#" onClick={() => setShowMobileNav(false)}>Home</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink exact={true} to="/inbox" className="nav-link" href="#" onClick={() => setShowMobileNav(false)}>
                                {inboxCount > 0 &&
                                    <span className="badge badge-pill badge-danger"
                                          style={{position: 'relative', top: '-10px', left: '-2px'}}
                                    >{inboxCount}</span>}
                                Inbox
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink exact={true} to="/my-requests" className="nav-link" href="#" onClick={() => setShowMobileNav(false)}>My Requests</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink exact={true} to="/search" className="nav-link" href="#" onClick={() => setShowMobileNav(false)}>Search</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink exact={true} to="/user/delegations" className="nav-link" href="#">Delegations</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink exact={true} to="/support" className="nav-link text-danger" href="#">Support</NavLink>
                        </li>
                    </ul>

                    <ul className="navbar-nav">
                        <li className="nav-item mr-3">
                            <div className="input-group">
                                <input type="text"
                                       className="form-control"
                                       style={{
                                           width: '80px'
                                       }}
                                       value={searchEntryId}
                                       onChange={(e) => setSearchEntryId(e.target.value.replace(/[^0-9]/, ''))}
                                       onKeyDown={(e) => {
                                           if (e.key === 'Enter') {
                                               handleSearchEntryById();
                                           }
                                       }}
                                />
                                <div className="input-group-append">
                                    <i
                                        className="fas fa-search input-group-text"
                                        style={{
                                            padding: '10px 8px',
                                            background: 'none',
                                            cursor: 'pointer'
                                        }}
                                        onClick={handleSearchEntryById}
                                    />
                                </div>
                            </div>
                        </li>
                        <li className="nav-item mr-3"
                            style={{
                                paddingTop: '6px'
                            }}
                        >
                            <DropdownMenu>
                                <i className={'far fa-bell' + (isRtmsConnected ? '' : ' text-black-50')} style={{fontSize: '150%'}}/>
                                <div className="dropdown-menu dropdown-menu-right show p-0" style={{width: '300px'}}>
                                    <h6 className="dropdown-header text-center">Notifications</h6>
                                    <div className="dropdown-divider m-0"></div>
                                    <div className="text-muted text-center pt-3 pb-3">
                                        <em>No Notifications</em>
                                    </div>
                                    {false && <h6 className="dropdown-header text-center">Show all notifications</h6>}
                                </div>
                            </DropdownMenu>
                        </li>
                        {false &&
                            <li className="nav-item mr-3"
                                style={{
                                    paddingTop: '6px'
                                }}
                            >
                                <DropdownMenu caret={true}>
                                    <span>English</span>
                                    <div className="dropdown-menu dropdown-menu-right show">
                                        <a className="dropdown-item" href="#">English</a>
                                        <a className="dropdown-item" href="#">French</a>
                                        <a className="dropdown-item" href="#">Spanish</a>
                                    </div>
                                </DropdownMenu>
                            </li>
                        }
                        <li className="nav-item"
                            style={{
                                marginTop: '-5px',
                                marginBottom: '-5px'
                            }}
                        >
                            <DropdownMenu>
                                <div>
                                    <img src={'https://fletch.abb.com/profile-photo/' + User.getInstance().getEmail()}
                                         className="img-thumbnail rounded-circle"
                                         style={{
                                             width: '45px',
                                             height: '45px',
                                             padding: 0,
                                             borderColor: '#aaa'
                                         }}/>
                                </div>
                                <div className="dropdown-menu dropdown-menu-right show">
                                    {false && <a className="dropdown-item" href="#">My Profile</a>}
                                    {false && <div className="dropdown-divider"/>}
                                    <a href="#"
                                       className="dropdown-item"
                                       onClick={(e) => {
                                           e.preventDefault();
                                           e.stopPropagation();
                                           dispatchUserLogout();
                                       }}
                                    >Log Out</a>
                                </div>
                            </DropdownMenu>
                        </li>
                    </ul>

                </div>
            }
        </nav>
    );
};

const mapStateToProps = (state: any) => ({
    isRtmsConnected: isConnected(state),
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
    return {
        dispatchUserLogout: () => {
            dispatch(logout());
        }
    };
};

const ConnectedNavbar = connect(mapStateToProps, mapDispatchToProps)(Navbar);
export {ConnectedNavbar as Navbar};